import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionProcessing.module.css";
import Header from '../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { login } from '../http/http';
import { useDispatch } from 'react-redux';
import { setUserToken } from '../store/slices/userTokenSlice';
import { useTranslation } from 'react-i18next';
import Lottie from 'lottie-react';
import waitAnimation from "../animations/waitAnimation.json";

const SubscriptionProcessing = () => {
    const location = useLocation();
    const [msisdn, setMsisdn] = useState(null);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
        }
        else {
            navigate("/");
        }
    }, [location]);

    // useEffect(() => {
    //     if (!loading) {
    //         const apiInterval = setInterval(() => {
    //             handleFormSubmission();
    //         }, 2000);
    //         return () => {
    //             clearInterval(apiInterval);
    //         }
    //     }

    // }, [loading]);

    // const handleFormSubmission = async () => {
    //     try {
    //         setLoading(true);
    //         await login({ msisdn: msisdn })
    //             .then((res) => {
    //                 setLoading(false);
    //                 dispatch(setUserToken(res?.data?.result?.token));
    //                 navigate("/home", { replace: true, state: null });
    //             })
    //             .catch((err) => {
    //                 setLoading(false);
    //                 console.log(err, 'err---');
    //             });
    //     } catch (error) {
    //         setLoading(false);
    //         console.log(error, 'error--');
    //     }
    // }

    return (
        <>
            <div className={classes.container}>
                <div className={classes.description}>
                    <h2 className={classes.title}>Subscription In Process</h2>
                    <ul className={classes.list}>
                        <li className={classes.text}>
                            Your subscription request is in process!
                        </li>
                        {/* <li className={classes.text}>
                            Please approve the subscription
                        </li> */}
                    </ul>

                    {/* <div className={classes.animation_container}>
                        <Lottie animationData={waitAnimation} loop autoPlay className={classes.animation} />
                    </div> */}

                    {/* <p className={classes.text2}>
                        {t("124")}
                    </p> */}
                </div>
            </div>
        </>

    )
}

export default SubscriptionProcessing

// 242066042662